module.exports = __webpack_public_path__ + "static/media/3.d1297790.JPG";